import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TravelerPaxResponse, TravelerPaxIdentificator } from '@pax/entities/traveler-pax';
import { TravelerTypes } from '@pax/entities/traveler-info';
import { PaxFormService } from '@pax/services/pax-form.service';
import { PaxDocumentsPipe } from '@pax/pipes/pax-documents.pipe';
import { BookingPaxTypeDocumentProps } from '@app/entities/booking-documents';
import { getPaxDocumentAbreviationById } from '@forms/mappers/form-document-input.mapper';

@Component({
  selector: 'app-each-item',
  templateUrl: './each-item.component.html',
  styleUrls: ['./each-item.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EachItemComponent {

  @Input() traveler: TravelerPaxResponse;
  @Input() type: TravelerTypes;
  @Input() isPassenger: boolean;
  @Input() isLast: boolean;
  @Input() totalItems: number;
  @Input() productCode: string;

  @Output() edit: EventEmitter<TravelerPaxResponse> = new EventEmitter();
  @Output() remove: EventEmitter<TravelerPaxIdentificator> = new EventEmitter();
  @Output() selectTraveler: EventEmitter<TravelerPaxResponse> = new EventEmitter();

  public showOptions: boolean = false;

  constructor(
    private paxFormService: PaxFormService,
    private paxDocumentsPipe: PaxDocumentsPipe
  ) { }

  get documents$(): Observable<BookingPaxTypeDocumentProps[]> {
    return this.paxDocumentsPipe.transform(this.type, this.traveler?.nationality);
  }

  get documentAbreviation$(): Observable<string> {
    return this.documents$.pipe(map(documents =>
      getPaxDocumentAbreviationById(documents, this.traveler?.configuration_document_id)));
  }

  get onlyOne(): boolean {
    return this.totalItems === 1;
  }

  get typeIcon(): string {
    return this.paxFormService.typePaxIcon(this.type);
  }

  public toggleOptions(): void {
    this.showOptions = !this.showOptions;
  }

  public removeItem(): void {
    this.remove.emit({
      configuration_document_id: this.traveler.configuration_document_id,
      document_number: this.traveler.document_number,
      _id: this.traveler._id,
      documentId: this.traveler.documentId,
    });
  }

}
